import { render, staticRenderFns } from "./RemittanceInfoCard.vue?vue&type=template&id=40af5b48&scoped=true&"
import script from "./RemittanceInfoCard.vue?vue&type=script&lang=js&"
export * from "./RemittanceInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./RemittanceInfoCard.vue?vue&type=style&index=0&id=40af5b48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40af5b48",
  null
  
)

export default component.exports